var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c("span", [_vm._v("添付ファイル一覧")]),
    _vm._v(" "),
    _c(
      "table",
      { staticClass: "unstriped boss-table pega-mb-20 pega-file-download" },
      [
        _c("thead", [
          _c("tr", [
            _c("th", { staticClass: "boss-table-head-center file-name" }, [
              _vm._v("\n          ファイル名\n        "),
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "boss-table-head-center" }, [
              _vm._v("\n          送信日時\n        "),
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "boss-table-head-center file-period" }, [
              _vm._v("\n          閲覧期限\n          "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: {
                        content:
                          "応募者がマイページ上でファイルを閲覧できる期限。これを過ぎると閲覧できなくなります。",
                      },
                      expression:
                        "{ content: '応募者がマイページ上でファイルを閲覧できる期限。これを過ぎると閲覧できなくなります。'}",
                    },
                  ],
                  staticClass: "pega-circle",
                },
                [_vm._v("?\n          ")]
              ),
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "boss-table-head-center file-operation" }, [
              _vm._v("\n          操作メニュー\n        "),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm.summaryFiles.length
              ? [
                  _vm._l(_vm.summaryFiles, function (summaryFile, i) {
                    return [
                      _c("entry-message-attachment-file", {
                        key: i,
                        attrs: {
                          "entry-id": _vm.entryId,
                          "summary-file": summaryFile,
                        },
                        on: {
                          fetchAllMessage: function ($event) {
                            return _vm.$emit("fetchAllMessage")
                          },
                        },
                      }),
                    ]
                  }),
                ]
              : _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "text-center boss-text",
                      attrs: { colspan: "4", "data-test": "no-file" },
                    },
                    [
                      _vm._v(
                        "\n          送信したファイルはありません。\n        "
                      ),
                    ]
                  ),
                ]),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }